'use strict';

var JSConstants = require('_core_ext/pages/tradecard/constants');
var CSSConstants = require('_core_ext/pages/tradecard/cssconstant');

function updateCompanyOwner (state) {
    var $companyOwner = $(JSConstants.CLASS_COMPANYOWNER_CHECK);

    if ($companyOwner && $companyOwner.length > 0) {
        $companyOwner.prop('checked', state);
        $companyOwner.val(state);
    }
}

function updateBarberQuestion (state) {
    var $barberQuestionCheckbox = $(JSConstants.BARBER_QUESTIONS_CHECK);

    if ($barberQuestionCheckbox && $barberQuestionCheckbox.length) {
        $barberQuestionCheckbox.prop('checked', state);
        $barberQuestionCheckbox.val(state);
    }
}

function initBarberEvents () {
    $(document)
        .on('click', JSConstants.BARBER_ACTIVATOR_BUTTON, function (e) {
            e.preventDefault();
            updateCompanyOwner(false);
            updateBarberQuestion(true);

            $(JSConstants.BARBER_QUESTIONS_EL).show();
            $(CSSConstants.STEPPER_STEP_ACIVE).addClass(CSSConstants._STEPPER_INFO_DISABLED);
            $(JSConstants.UPLOADER).trigger('change');
        })
        .on('click', JSConstants.BARBER_GO_BACK_BUTTON, function (e) {
            e.preventDefault();
            updateCompanyOwner(true);
            updateBarberQuestion(false);

            $(JSConstants.BARBER_QUESTIONS_EL).hide();
            $(CSSConstants.STEPPER).removeClass(CSSConstants._STEPPER_INFO_DISABLED);
            $(JSConstants.UPLOADER).trigger('change');
        });
}

module.exports = {
    init: function () {
        initBarberEvents();
    }
};